import React from "react";
import {
  Datagrid,
  EditButton,
  DeleteButton,
  List,
  Loading,
  TextField,
  BooleanField,
  useMutation,
  useRedirect,
  FilterButton,
  FilterForm,
  TopToolbar,
  TextInput,
  CreateButton,
} from "react-admin";
import { Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { CustomExportButton, CustomImportButton } from "../../Signet/util";

const NetsuiteDesignPatternResources = "netsuite/design-pattern";

const useStyles = makeStyles({
  container: {
    width: "100%",
    padding: 0,
  },
});

const DesignPatternFilters = [
  <TextInput source="name" label="Name" defaultValue="" />,
  <TextInput source="sku_code" label="Sku Code" defaultValue="" />,
  <TextInput source="netsuite_id" label="Netsuite ID" defaultValue="" />,
  <TextInput source="netsuite_value" label="Netsuite Value" defaultValue="" />,
];

const DesignPatternListActions = (props) => {
  const classes = useStyles();
  return (
    <TopToolbar className={classes.container}>
      <Box
        display={"flex"}
        alignItems={"flex-end"}
        justifyContent="space-between"
        width={"100%"}
        sx={{ paddingBottom: "14px" }}
      >
        <Box
          display={"flex"}
          alignItems={"center"}
          justifyContent="space-between"
        >
          <FilterForm filters={DesignPatternFilters} />
        </Box>
        <Box display={"flex"} justifyItems={"flex-end"} sx={{ gap: "20px" }}>
          <CustomImportButton resource={NetsuiteDesignPatternResources} />
          <CustomExportButton resource={NetsuiteDesignPatternResources} />
          <FilterButton filters={DesignPatternFilters} />
          <CreateButton />
        </Box>
      </Box>
    </TopToolbar>
  );
};

const CustomEdit = ({ record }) => {
  const redirect = useRedirect();
  const designPatternId = record.id;
  const [getDetails] = useMutation({
    type: "getOne",
    resource: NetsuiteDesignPatternResources,
    payload: { id: designPatternId },
  });

  const handleEdit = async (e) => {
    e.preventDefault();
    getDetails();
    redirect(`/${NetsuiteDesignPatternResources}/${designPatternId}`);
  };

  return <EditButton onClick={handleEdit} />;
};

const DesignPatternList = (props) => {
  const { permissions } = props;

  if (!permissions) return <Loading />;
  const permissionsList = permissions.split(",");
  return (
    <List {...props} exporter={false} actions={<DesignPatternListActions />}>
      <Datagrid rowClick={null}>
        <TextField source="name" label="Name" sortable={false} />
        <TextField source="sku_code" sortable={false} label="Sku Code" />
        <BooleanField source="is_inside" label="Is Inside" sortable={false} />
        <BooleanField source="is_reverse" label="Is Reverse" sortable={false} />
        <TextField source="netsuite_id" sortable={false} label="Netsuite ID" />
        <TextField source="netsuite_value" sortable={false} label="Netsuite Value" />
        <CustomEdit />
        {permissionsList.includes("delete_material_data") && (
          <DeleteButton label="" undoable={false} />
        )}
      </Datagrid>
    </List>
  );
};

export default DesignPatternList;

